import React,{useState,useEffect} from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import AllDetailpartb from '../allDetailpartb';
import Showdetailjournal from'../../../form01/components/showdetailjournal';
import Jorunaldetailpartb from '../journalDetailAll/jorunaldetailpartb';


function Detailrevision({jourId,codeId}) {
    const [key, setKey] = useState('jouranl');
  return (
    <div className='form-body-page'>
    <form >
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
        className="mb-3"
      >
        <Tab eventKey="jouranl" title="TECHNICAL DATA SHEET A" style={{ backgroundColor: 'aliceblue' }}>
          <Showdetailjournal id={jourId} />
        </Tab>
        <Tab eventKey="journaldetailpartb" title="TECHNICAL DATA SHEET B" style={{ backgroundColor: 'aliceblue' }}>
          <AllDetailpartb journalId={jourId} />
        </Tab>
      </Tabs>
    </form>
  </div>
  )
}

export default Detailrevision